import { nFormatter, Row } from "@asayinc/component-library";
import { createColumnData } from "../../../../../utils";
import { ITopShareholder } from "../../../../../store/allNetworkStats/types";
import { TableEventData } from "../../../../../types/Table";

export const getColumnData = () => ({
  name: createColumnData({
    title: "Name",
    style: "text",
    width: "300px",
  }),
  shares_owned: createColumnData({
    title: "Shares Owned",
    style: "text",
    width: "200px",
  }),
  shares_value: createColumnData({
    title: "Current Share Value",
    style: "text",
    width: "200px",
  }),
  location: createColumnData({
    title: "Location",
    style: "text",
    width: "300px",
  }),
});

interface CreateTopShareholdersRowData {
  id: string;
  name: string;
  sharesOwned: string;
  shareValue: number | null;
  location: string;
  data: TableEventData;
}

export const createRowData = ({
  id,
  name,
  sharesOwned,
  shareValue,
  location,
  data,
}: CreateTopShareholdersRowData): Row => ({
  rowData: {
    name: { content: name },
    shares_owned: { content: nFormatter(parseFloat(sharesOwned)) },
    shares_value: {
      content: shareValue
        ? new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
          }).format(shareValue)
        : "N/A",
    },
    location: { content: location },
  },
  id,
  data,
});

export const getRowData = ({
  shareholders,
}: {
  shareholders: ITopShareholder[];
}) =>
  shareholders.map((shareholder, idx) =>
    createRowData({
      id: `${idx}`,
      name: shareholder.name || "N/A",
      sharesOwned: shareholder.sharesOwned,
      shareValue: shareholder.sharesValue,
      location: shareholder.location || "N/A",
      data: { id: `${idx}` },
    })
  );
